import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Linkedin } from "lucide-react";
import { LOGO_URL, NAV_ITEMS, CONTACT_INFO } from "@/data/siteData";

const Footer = () => (
  <footer className="bg-slate-900 text-white py-12" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
        {/* Logo & Description */}
        <div className="md:col-span-2">
          <img
            src={LOGO_URL}
            alt="Outsource Point"
            className="h-10 mb-4 brightness-0 invert"
          />
          <p className="text-slate-400 max-w-md">
            Аутсорс Пойнт е българска компания, специализирана в кол център
            услуги и управление на чат канали. Предоставяме професионално
            обслужване на клиенти на български и английски език.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-semibold text-lg mb-4">Бързи връзки</h4>
          <ul className="space-y-2">
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <Link
                  to={item.href}
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  {item.label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/zapazi-chas"
                className="text-slate-400 hover:text-white transition-colors"
              >
                Запазете час
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-semibold text-lg mb-4">Контакти</h4>
          <ul className="space-y-3 text-slate-400">
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4" />
              <a
                href={`mailto:${CONTACT_INFO.email}`}
                className="hover:text-white transition-colors"
              >
                {CONTACT_INFO.email}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4" />
              <a
                href={`tel:${CONTACT_INFO.phone}`}
                className="hover:text-white transition-colors"
              >
                {CONTACT_INFO.phone}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-1" />
              <span>{CONTACT_INFO.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-slate-500 text-sm">
          © {new Date().getFullYear()} Outsource Point Group. Всички права запазени.
        </p>
        <div className="flex flex-col items-center md:items-end gap-3">
          <div className="flex gap-4">
            <a
              href={CONTACT_INFO.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-500 hover:text-white transition-colors"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href={CONTACT_INFO.linkedin}
              className="text-slate-500 hover:text-white transition-colors"
            >
              <Linkedin className="w-5 h-5" />
            </a>
          </div>
          <p className="text-slate-500 text-sm">
            Web Design &amp; Development:{" "}
            <a
              href="https://nedkov-digital.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-[#4169E1] transition-colors font-medium"
              data-testid="footer-nedkov-digital-link"
            >
              NedkovDigital
            </a>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
